// today
const minDateNow = () => {
  let isNow = new Date()
  let month = isNow.getMonth() + 1
  let day = isNow.getDate()
  let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + (('' + day).length < 2 ? '0' : '') + day
  return today
}

export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  garages: [],
  rent: {
    car_id: null,
    tower_id: null,
    unit_id: null,
    garage_id: null,
    date_go_in: null,
    date_go_out: null,
    status: true
  },
  rents: [],
  entity: 'rent',
  entities: 'rents',
  dwellerUnits: [],
  dwellerTowers: [],
  optionUnits: [],
  optionTowers: [],
  optionStatus: [
    {
      id: true,
      label: 'Ativo'
    },
    {
      id: false,
      label: 'Inativo'
    }
  ],
  minDate: minDateNow(),
  prefixRouter: 'tenant.rent.parking'
})



// WEBPACK FOOTER //
// ./src/app/tenant/rent-parking/resources/data.js